import { ApiGuessedLocation } from 'api/types/ApiGuessedLocation';
import { getItem } from 'utils/localStorage';

export function getInitialSearchLocation(
  guessedLocation: ApiGuessedLocation
): SearchLocation {
  return (
    getItem('searchLocation') || {
      ...guessedLocation,
      geoType: 'ipAddress',
      boundingBoxN: null,
      boundingBoxS: null,
      boundingBoxW: null,
      boundingBoxE: null,
    }
  );
}
